import { useRef, type ReactNode } from "react";

/** Capture-first photo picking: `openPicker()` pops the native photo sheet
 *  (library / camera / files) immediately, with no app UI underneath; the
 *  callback fires only when a photo was actually chosen — cancelling leaves
 *  the screen untouched. Render `photoInput` once wherever the hook is used. */
export function usePhotoPicker(onPicked: (file: File) => void): {
  openPicker: () => void;
  photoInput: ReactNode;
} {
  const ref = useRef<HTMLInputElement | null>(null);
  const openPicker = () => ref.current?.click();
  const photoInput = (
    <input
      ref={ref}
      type="file"
      accept="image/*"
      className="hidden"
      onChange={(e) => {
        const f = e.target.files?.[0];
        e.target.value = ""; // allow picking the same photo again later
        if (f) onPicked(f);
      }}
    />
  );
  return { openPicker, photoInput };
}
